var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.openTabSettings
    }
  }, [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1), _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    model: {
      value: _vm.openModal,
      callback: function callback($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('tabsettings_tab_settings')))]), _c('v-card-text', [_c('div', {
    staticClass: "my-5"
  }, [_c('div', {
    staticClass: "text-caption font-weight-bold label"
  }, [_vm._v(_vm._s(_vm.$t('tabsettings_tab_name')) + ":")]), _c('v-text-field', {
    attrs: {
      "counter": "",
      "dense": "",
      "maxlength": "16",
      "placeholder": _vm.$t('tabsettings_tab_name_placeholder')
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('div', {
    staticClass: "my-5"
  }, [_c('div', {
    staticClass: "text-caption font-weight-bold label"
  }, [_vm._v(_vm._s(_vm.$t('tabsettings_tab_icon')) + ":")]), _c('icon-picker', {
    attrs: {
      "active": _vm.form.icon
    },
    on: {
      "selectIcon": _vm.selectIcon
    }
  })], 1), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "checkbox-ctn"
  }, [_c('div', {
    staticClass: "text-caption font-weight-bold label"
  }, [_vm._v(_vm._s(_vm.$t('tabsettings_shown_for_scan_result')) + ":")]), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "hide-defails": "",
      "dense": "",
      "label": _vm.$t('genuine')
    },
    model: {
      value: _vm.form.visibility.genuine,
      callback: function callback($$v) {
        _vm.$set(_vm.form.visibility, "genuine", $$v);
      },
      expression: "form.visibility.genuine"
    }
  }), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "hide-defails": "",
      "dense": "",
      "label": _vm.$t('active_code')
    },
    model: {
      value: _vm.form.visibility.active,
      callback: function callback($$v) {
        _vm.$set(_vm.form.visibility, "active", $$v);
      },
      expression: "form.visibility.active"
    }
  }), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "hide-defails": "",
      "dense": "",
      "label": _vm.$t('unable_to_verify')
    },
    model: {
      value: _vm.form.visibility.fake,
      callback: function callback($$v) {
        _vm.$set(_vm.form.visibility, "fake", $$v);
      },
      expression: "form.visibility.fake"
    }
  })], 1) : _vm._e()]), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": _vm.deleteTab
    }
  }, [_vm._v(_vm._s(_vm.$t('tabsettings_remove_this_tab')))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }